import { Component, OnInit, Input } from "@angular/core";
import { ApiConnectorService } from "src/app/___LOGIC/__api/api-connector.service";
import { ResolverService } from "src/app/___LOGIC/__common/resolver.service";
import { GuiFlowService } from "src/app/___LOGIC/__gui/gui-flow.service";


@Component({
  selector: 'app-smart-toggle',
  templateUrl: './smart-toggle.component.html',
  styleUrls: ['./smart-toggle.component.css']
})
export class SmartToggleComponent implements OnInit {

  @Input() config;
  @Input() element;

  currentValue;

  loading = false;

  constructor(private apiConnector: ApiConnectorService,private guiFlow: GuiFlowService,private resolver: ResolverService) {}

  ngOnInit(): void {
    if(!this.config){
      this.config = {
        queryId: 'get',
        queryParam1: null,
        queryParam2: null,
        queryParam3: null,
        queryParam4: null,
        currentObj: null,
        bindingLabel: 'active',
        toggleLabelActive: 'Active',
      }
    }

    // LOAD VALUE
    if(this.element){
      this.currentValue = this.element[this.config.bindingLabel];
    }

  }

  toogleActive(element){
    this.loading = true;
    element[this.config.bindingLabel]? element[this.config.bindingLabel] = '0': element[this.config.bindingLabel] = '1';
    this.config.queryParam2 = element.id;
    this.config.currentObj = element;
    this.apiConnector.voyjaleasApiRequest(
      this.config.queryId,
      this.config.queryParam1,
      this.config.queryParam2,
      this.config.queryParam3,
      element[this.config.bindingLabel],
      this.config.currentObj,
      ).subscribe(obj => this.processChange(obj));
  }

  processChange(res){
    if(res && res.OK){
      //this.guiFlow.openSimpleSnackBar('Actualizado con éxito','Ok');
      this.loading = false;
    }else{
      this.guiFlow.openSimpleSnackBar('Error','error');
      this.loading = false;
    }
  }

  isLoading(){
    return this.loading;

  }

  isElementActive(){
    if(this.config){
      return this.element[this.config.bindingLabel] == 1
      || this.element[this.config.bindingLabel] == '1' || this.element[this.config.bindingLabel] == 'true';
    }else{
      return false;
    }

  }

  getLabel(){
    let label;
    if( this.config){
      this.config.toggleLabelActive? label = this.config.toggleLabelActive : label = 'default';
    }else{
      label = '';
    }
    return label;
  }

}
